export const SET_SIDEBAR_COLORS = "SET_SIDEBAR_COLORS";
export const SET_BODY_COLORS = "SET_BODY_COLORS";
export const SET_CARD_COLORS = "SET_CARD_COLORS";
export const SET_FOOTER_COLORS = "SET_FOOTER_COLORS";
export const SET_HEADER_COLORS = "SET_HEADER_COLORS";
